(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('agent-category-access', {
                parent: 'entity',
                url: '/agent-category-access?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentCategoryAccess.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-category-access/agent-category-accesses.html',
                        controller: 'AgentCategoryAccessController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentCategoryAccess');
                        $translatePartialLoader.addPart('agentCategoryAccessType');
                        $translatePartialLoader.addPart('agentCategoryViewMode');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('agent-category-access-detail', {
                parent: 'entity',
                url: '/agent-category-access/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentCategoryAccess.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-category-access/agent-category-access-detail.html',
                        controller: 'AgentCategoryAccessDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentCategoryAccess');
                        $translatePartialLoader.addPart('agentCategoryAccessType');
                        $translatePartialLoader.addPart('agentCategoryViewMode');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AgentCategoryAccess', function ($stateParams, AgentCategoryAccess) {
                        return AgentCategoryAccess.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('agent-category-access.new', {
                parent: 'agent-category-access',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-category-access/agent-category-access-dialog.html',
                        controller: 'AgentCategoryAccessDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    accessType: null,
                                    viewMode: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('agent-category-access', null, {reload: true});
                    }, function () {
                        $state.go('agent-category-access');
                    });
                }]
            })
            .state('agent-category-access.edit', {
                parent: 'agent-category-access',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-category-access/agent-category-access-dialog.html',
                        controller: 'AgentCategoryAccessDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['AgentCategoryAccess', function (AgentCategoryAccess) {
                                return AgentCategoryAccess.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-category-access', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('agent-category-access.delete', {
                parent: 'agent-category-access',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-category-access/agent-category-access-delete-dialog.html',
                        controller: 'AgentCategoryAccessDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['AgentCategoryAccess', function (AgentCategoryAccess) {
                                return AgentCategoryAccess.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-category-access', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
